import { Button, cn, useLocalization } from '@magicdoorinc/ui';
import IconCheck from '~/assets/images/common/check.svg?component-solid';
import { useCompanyTypeConfirm } from '~/contexts/local';
import type { Component } from 'solid-js';

const SelectCompanyTypeContent: Component = () => {
  const { t } = useLocalization();
  const { resolveSelfManagedStore, handleCompanyTypeChange } = useCompanyTypeConfirm();

  return (
    <div class="flex flex-col gap-4 p-6 pt-8">
      <div class="mb-4 text-center text-2xl font-semibold text-text-01">{t('Which best describes you?')}</div>

      <div
        class={cn(
          'relative mt-2 flex cursor-pointer flex-col gap-3 rounded-xl border p-5 transition-all',
          resolveSelfManagedStore.selfManaged === true ? 'border-primary bg-white' : 'border-gray-200 bg-white hover:border-primary/50'
        )}
        onClick={() => handleCompanyTypeChange(true)}>
        <div class="absolute -top-3 left-4 bg-white px-1 text-xs font-medium text-text-01">{t('Recommended for most owners')}</div>
        <div class="flex items-start gap-3">
          <div
            class={cn(
              'mt-1 flex size-5 shrink-0 items-center justify-center rounded-full border-2 transition-colors',
              resolveSelfManagedStore.selfManaged === true ? 'border-primary bg-primary' : 'border-gray-300'
            )}>
            {resolveSelfManagedStore.selfManaged === true && <IconCheck class="-ml-1 -mt-1.5 size-3.5 text-white" />}
          </div>
          <div class="flex flex-col gap-3">
            <h3
              class={cn(
                'text-lg font-medium leading-normal',
                resolveSelfManagedStore.selfManaged === true ? 'text-primary' : 'text-text-01'
              )}>
              {t('I manage only my own properties')}
            </h3>
            <div class="flex flex-col gap-2 text-sm text-text-02">
              <div class="flex items-start gap-2">
                <IconCheck class="mt-0.5 size-4 shrink-0 text-primary" />
                <span>{t('No other owners to report to')}</span>
              </div>
              <div class="flex items-start gap-2">
                <IconCheck class="mt-0.5 size-4 shrink-0 text-primary" />
                <span>{t('Simpler setup — everything stays in one place')}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class={cn(
          'relative flex cursor-pointer items-start gap-3 rounded-xl border p-5 transition-all',
          resolveSelfManagedStore.selfManaged === false ? 'border-primary bg-white' : 'border-gray-200 bg-white hover:border-primary/50'
        )}
        onClick={() => handleCompanyTypeChange(false)}>
        <div
          class={cn(
            'mt-1 flex size-5 shrink-0 items-center justify-center rounded-full border-2 transition-colors',
            resolveSelfManagedStore.selfManaged === false ? 'border-primary bg-primary' : 'border-gray-300'
          )}>
          {resolveSelfManagedStore.selfManaged === false && <IconCheck class="-ml-1 -mt-1.5 size-3.5 text-white" />}
        </div>
        <div class="flex flex-col gap-1">
          <h3
            class={cn(
              'text-lg font-medium leading-normal',
              resolveSelfManagedStore.selfManaged === false ? 'text-primary' : 'text-text-01'
            )}>
            {t('I manage properties for other people')}
          </h3>
          <p class="text-sm text-text-02">{t('I need to track income separately and report to property owners')}</p>
        </div>
      </div>
    </div>
  );
};

export const SelectCompanyTypeFooter: Component = () => {
  const { t } = useLocalization();
  const { resolveSelfManagedStore, handleSelectCompanyType } = useCompanyTypeConfirm();

  return (
    <div class="flex items-center justify-end border-t border-separator bg-white px-6 py-4">
      <Button onClick={handleSelectCompanyType} disabled={resolveSelfManagedStore.selfManaged === undefined} class="px-8">
        {t('Next')}
      </Button>
    </div>
  );
};

export default SelectCompanyTypeContent;
